import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { Calendar, User, ChevronRight, Search } from "lucide-react";
import { Input } from "../components/ui/input";
import { api } from "../api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/blog")
      .then((r) => setPosts(r.data || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = posts.filter((p) =>
    p.title.toLowerCase().includes(q.toLowerCase()) ||
    (p.excerpt || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <SEO title="OnlineCricketID Blog - Cricket ID Guides, IPL Tips & Updates" description="Latest articles on Cricket ID, sports exchange tips, IPL guides, and OnlineCricketID platform updates by industry experts." />
      <PageHero title="OnlineCricketID Blog" breadcrumb="Blog" subtitle="Cricket ID, betting tips, exchange guides, IPL analysis aur Anna ke personal experiences - sab kuch yahan." />

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 max-w-md mb-8">
            <div className="relative flex-1">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles..." className="pl-9 bg-[#0c1530] border-white/10 text-white placeholder:text-slate-500 focus-visible:ring-amber-500" />
            </div>
          </div>

          {loading ? (
            <div className="text-center py-20 text-slate-400">Loading posts...</div>
          ) : filtered.length === 0 ? (
            <div className="text-center py-20 text-slate-400">No posts found</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((p) => (
                <Link to={`/blog/${p.slug}`} key={p.slug} className="card-dark overflow-hidden group flex flex-col">
                  <div className="relative h-48 overflow-hidden">
                    {p.cover && <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1226] via-transparent to-transparent" />
                  </div>
                  <div className="p-5 flex-1 flex flex-col">
                    <div className="flex items-center gap-3 text-xs text-slate-400">
                      <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {p.date}</span>
                      <span className="flex items-center gap-1"><User className="w-3.5 h-3.5" /> {p.author}</span>
                    </div>
                    <h3 className="mt-3 text-lg font-bold text-white leading-snug group-hover:text-amber-300 transition-colors">{p.title}</h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <div className="mt-4 inline-flex items-center gap-1 text-amber-400 text-sm font-semibold">Read more <ChevronRight className="w-4 h-4" /></div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
